import { render, staticRenderFns } from "./goods_type.vue?vue&type=template&id=6e4305c2&scoped=true"
import script from "./goods_type.vue?vue&type=script&lang=js"
export * from "./goods_type.vue?vue&type=script&lang=js"
import style0 from "./goods_type.vue?vue&type=style&index=0&id=6e4305c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4305c2",
  null
  
)

export default component.exports